import client from '../httpClient';

const divisionsGetMangerApi = (divisionId) => {
  return client.get(`/divisions/manager/${divisionId}`);
};

export default divisionsGetMangerApi;
